
import makerjs from "makerjs";
/**
 * 计算两点间的弦长
 * @param {Object} p1 - 第一个点坐标 {x, y}
 * @param {Object} p2 - 第二个点坐标 {x, y}
 * @returns {number} 弦长值
 */
 function calculateChordLength(p1, p2) {
  const dx = p2.x - p1.x;
  const dy = p2.y - p1.y;
  return Math.sqrt(dx*dx + dy*dy);
}
//已知劣弧上两点坐标及半径，求圆心坐标劣弧中心点坐标。
function optimizedArcMidpoint(start, end, radius) {
  // 1. 预计算差值避免重复计算
  const dx = end.x - start.x;
  const dy = end.y - start.y;
  const dSquared = dx * dx + dy * dy;

  // 快速检查半径有效性
  if (dSquared > 4 * radius * radius) return null; // 使用平方比较避免开方运算

  // 2. 计算中点（仅需一次加法运算）
  const midX = (start.x + end.x) * 0.5;
  const midY = (start.y + end.y) * 0.5;

  // 3. 计算垂直向量（优化单位化过程）
  const invD = 1 / Math.sqrt(dSquared);
  const ux = dy * invD;  // 单位垂直向量x分量
  const uy = -dx * invD; // 单位垂直向量y分量

  // 4. 计算圆心（单解模式，直接选择劣弧圆心）
  const h = Math.sqrt(radius * radius - dSquared * 0.25);
  const center = {
    x: midX + h * ux,
    y: midY + h * uy
  };

  // 5. 向量法计算中点（优化单位化过程）
  const v1x = start.x - center.x;
  const v1y = start.y - center.y;
  const v2x = end.x - center.x;
  const v2y = end.y - center.y;

  // 单位向量相加
  const sumX = v1x + v2x;
  const sumY = v1y + v2y;
  const invLen = radius / Math.sqrt(sumX * sumX + sumY * sumY);

  return {
    x: center.x + sumX * invLen,
    y: center.y + sumY * invLen
  };
}
function C20(model, zoom, Param, fixedParam) {
  //w,h,w1,w2
  console.log("Param==", Param[0].param);
  console.log("Param==", Param[1].param);
  console.log("Param==", Param);
  var plate = model.plate, markers = model.markers, myZoom = zoom * 1,
  W = Param[0].param,R1 = Param[1].param, R2 = Param[2].param,   
    //  plate = model.plate, markers = model.markers,
    markShift = fixedParam.markShift * 1, markShiftTwo = fixedParam.markShiftTwo * 1,
    markShiftThree = fixedParam.markShiftThree * 1, markShiftFour = fixedParam.markShiftFour * 1, markHolesOneD = fixedParam.markHolesOneD * 1,

    r1 = R1 * 1 * myZoom,
    r2 = R2 * 1 * myZoom,
    w = W * 1 * myZoom,
    /**
     * 已知弦长半径求拱高
     * H=R-Math.sqrt((R*R)-(L/2)*(L/2))
     * 
     */
    w0=w*r2/r1,
     HH1=r1-Math.sqrt((r1*r1)-(w/2)*(w/2)),
     HH2=r2-Math.sqrt((r2*r2)-(w0/2)*(w0/2)),
    h=r1-r2+HH2,
    x0 = -w0/2,  y0 = r2-HH2,
    x1 = -w/2, y1 = r1-HH1,
    x2 = w/2,  y2 = r1-HH1, 
    x3 = w0/2,  y3 = r2-HH2,   
    ox=0,oy=0,
     glassH = h, glassW = w;
 

  if (r1 !== 0) {
    var TxtR1 = "R1=" +R1;
  } if (r2 !== 0) {
    var TxtR2 ="R2=" + R2;
  } if (w !== 0) {
    var TxtW = "W=" + W;
  }



  var drawAbnormalShapeC20 = {
    paths: {
      "LeftLine": new makerjs.paths.Line([x0, y0], [x1, y1]),
      "RightArcLine": new makerjs.paths.Arc([x1, y1], [x2, y2], r1, false, true),
      "BottomLine": new makerjs.paths.Line([x2, y2], [x3, y3]),      
      "LeftArcLine": new makerjs.paths.Arc([x0, y0], [x3, y3], r2, false, true),
    }
  };
  var drawAbnormalShapeC20MarkW = {
    paths: {
      "BottomLine": new makerjs.paths.Line([x1, y1+HH1+markShift], [x2, y2+HH1+markShift]),
      "LeftShortLine": new makerjs.paths.Line([x1, y1+HH1+markShift], [x1, y1+HH1+2*markShift]),
      "RightShortLine": new makerjs.paths.Line([x2, y2+HH1+markShift], [x2, y2+HH1+2*markShift]),
    }
  };
  var drawAbnormalShapeC20MarkR1 = {
    paths: {
      "BottomLine": new makerjs.paths.Line([0, r1], [0, r1-5*markShift]),
    }
  };
  var drawAbnormalShapeC20MarkR2 = {
    paths: {
      "BottomLine": new makerjs.paths.Line([0, r2], [0, r2-5*markShift]),
    }
  };
  makerjs.model.addCaption(drawAbnormalShapeC20MarkR1, TxtR1, [0-3*markShift, r1-7*markShift], [0+3*markShift, r1-7*markShift]);//长度文字  
  makerjs.model.addCaption(drawAbnormalShapeC20MarkW, TxtW, [x1, y1+HH1+3*markShift], [x2, y2+HH1+3*markShift]);//宽度文字
  makerjs.model.addCaption(drawAbnormalShapeC20MarkR2, TxtR2, [0-3*markShift, r2-7*markShift], [0+3*markShift, r2-7*markShift]);//宽度文字

  plate = {
    models: {
      drawAbnormalShapeC20: drawAbnormalShapeC20,
    }
  };
  markers = {
    models: {
      drawAbnormalShapeC20: drawAbnormalShapeC20,
      drawAbnormalShapeC20MarkR1: drawAbnormalShapeC20MarkR1,
      drawAbnormalShapeC20MarkW: drawAbnormalShapeC20MarkW,
      drawAbnormalShapeC20MarkR2: drawAbnormalShapeC20MarkR2,
    }
  };

  /*****************************************************************************/
  //return { plate, markers, glassW, glassH }

  return { w, h, plate, markers }
};


export default C20;